import React, { useEffect, useContext } from "react";

import Context from "../../../context";
import AccountItem from "./AccountItem";
import Pagination from "../Layout/Pagination";
import PageSection from "../Layout/PageSection";
import {PAGINATION_LIST} from "../../data/constants";

export default function AccountList({ isLoading,
                                      currentPage,
                                      perPage,
                                      numItems,
                                      paginate,
                                      setPerPage,
                                    }) {
  const { contextState, setContextState } = useContext(Context);

  useEffect(() => {
    setContextState({
      ...contextState,
      /*accounts: contextState.accounts.sort((a, b) => {
        if (a.status === "PastDue" || a.status === "ShutOff") return -2;
        if (a.status === "Due" && a.status === "DueSoon") return -1;
        if (a.status === "Paid") return 1;
        return 0;
      }),*/
    });
  }, [contextState.accounts]);

  return (
    <div className="account-list-container">
      <ul className="account-list">
        {isLoading ? (
          <div className="d-flex justify-content-center align-items-center">
            <div className="spinner-border mr-4" role="status"/>
            <h4>Loading Accounts...</h4>
          </div>
        ) : (
          <>
            {contextState.accounts.length > 0 &&
            <PageSection>
              <ul className="payment-hist-item-list">
                {contextState.accounts.map((account) => {
                  return <AccountItem key={account.customerNumber} account={account} />;
                })}
              </ul>
              <div className="col"></div>
              <div className="pagination-container row">
              <Pagination
                  currentPage={currentPage}
                  perPage={perPage}
                  numItems={numItems}
                  paginate={paginate}
              />
              <div className="col-sm">
                  <div className="form-section">
                      <div className="form-group">
                          <label className="form-label"></label>
                          <select
                              className="form-control dropdown"
                              placeholder="Select"
                              onChange={(e) => setPerPage(e.target.value)}>
                              {PAGINATION_LIST.map((value, index) => {
                                  return (
                                      <option value={value.value} key={index}>
                                          {value.text}
                                      </option>
                                  );
                              })}
                          </select>
                      </div>
                  </div>
              </div>
              </div>
            </PageSection>
            }
          </>
        )}
      </ul>
    </div>
  );
}
